import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconContactAssignee = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 52 40",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 0a1 1 0 0 0-1 1v5H3a3 3 0 0 0-3 3v28a3 3 0 0 0 3 3h46a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5V1a1 1 0 0 0-1-1h-7a1 1 0 0 0-1 1v5H17V1a1 1 0 0 0-1-1H9Zm2.5 2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-2Zm26.5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-7ZM45 19H28v2h17v-2Zm-17 4h17v2H28v-2Zm17 4H28v2h17v-2Zm-21 5H7s-.1-4.88 3-5.5c1.279-.256 1.903.142 2.61.592.675.43 1.424.908 2.89.908 1.523 0 2.35-.48 3.084-.906.712-.413 1.335-.774 2.416-.594 3 .5 3 5.5 3 5.5Zm-8.5-18a4.5 4.5 0 0 0-4.5 4.5v2a4.5 4.5 0 1 0 9 0v-2a4.5 4.5 0 0 0-4.5-4.5Z"
	})
});
export default SvgIconContactAssignee;
